@for (item of bundleOptions; track $index; let isFirst = $first) {
<div class="p-a-2 bg-col-5"
     [class.m-t-2]="!isFirst">
    <div class="w-1 w-2-m w-2-s p-r-1 p-r-3-m p-r-3-s">
        <div class="ratio-1-1">
            <img class="rf"
                 [image]="item.product.data?.image"
                 [attr.alt]="item.product.data?.name">
        </div>
    </div>
    <div class="w-11 w-10-m w-10-s p-l-2-x p-l-2-l">
        <div class="flex flex-justify-between">
            <span class="p2">{{ item.product.data?.name }}</span>
            <div>
                <p class="p2"
                   *ifTradeStore>
                    <span class="col-12">{{ 'Quantity' | translate }}:</span> {{ item.qty }}
                </p>
                <ng-container *ifNotTradeStore>
                    <!-- org price for discount -->
                    @if (item.product.orgPrice) {
                    <price class="inline-block m-r-2 col-12 va-m line-through s2 price"
                           [value]="item.product.orgPrice"></price>
                    }
                    <!-- final price -->
                    <price class="inline-block va-m s2 price"
                           [value]="item.product.price!"></price>
                </ng-container>
            </div>
        </div>
        <p class="m-t-1 col-12 p3">
            {{ item.product.data?.size | optionLabel : 'size' }}
            @if (item.product.data?.size && item.product.data?.color) {
            &nbsp;|&nbsp;
            }
            {{ item.product.data?.color | optionLabel : 'color' }}
        </p>
    </div>
</div>
}